import { HeaderGroup, PostRequest } from "../../Api/ApiFunctions";
import { ApiUrl } from "../../Api/EndPoints";

export const Sitevariables = {
  home: {
    banner: [
      {
        key: "",
        image: "",
        heading: "",
        subHeading: "",
        ctaBtn: "",
        ctaLink: "",
      },
    ],
    section1: {
      count: "",
      heading: "",
      body: "",
      ctaBtn: "",
      ctaLink: "",
    },
    section2: {
      heading: "",
      body: "",
    },
    goingGreen: {
      image: [],
      heading: "",
      subheading: "",
      body: "",
      notes: "",
    },
    goingGreenImages: [
      {
        key: "",
        image: "",
      },
    ],
    counts: {
      established: "",
      locations: "",
      projects: "",
    },
    productRange: {
      heading: "",
      points: {
        heading: "",
        points: [],
      },
      ctaBtn: "",
      ctaLink: "",
    },
    productRangeImages: [
      {
        key: "",
        image: "",
      },
    ],
  },
  about: {
    banner: {
      key: "",
      image: "",
      heading: "",
      subHeading: "",
    },
    about: {
      key: "",
      image: "",
      heading: "",
      subHeading: "",
    },
    whyUs: {
      excellence: "",
      quality: "",
      experience: "",
      integrity: "",
      collaboration: "",
      customerFocus: "",
    },
  },
  turkey: {
    banner: {
      key: "",
      image: "",
      heading: "",
      subHeading: "",
    },
    section1: "",
    section2: "",
    turnkey: {
      key: "",
      image: "",
      heading: "",
      subHeading: "",
    },
  },
  productRange: {
    banner: {
      key: "",
      image: "",
      heading: "",
      subHeading: "",
    },
    imageSet: [
      {
        key: "",
        image: "",
      },
    ],
    products: [
      {
        heading: "",
        points: [],
        link: "",
      },
    ],
  },
  valves: {
    banner: [
      {
        key: "",
        image: "",
        heading: "",
        subHeading: "",
      },
    ],
    section1: {
      headingLeft: "",
      subHeadingLeft: "",
      headingRight: "",
      subHeadingRight: "",
    },
    section2: {
      key: "",
      image: "",
      heading: "",
      subHeading: "",
    },
    valves: [
      {
        heading: "",
        points: [],
      },
    ],
  },
  career: {
    subHeading: "",
  },
  element: {
    mainLogo: {
      key: "",
      image: "",
    },
    valveLogo: {
      key: "",
      image: "",
    },
    bulletinLogo: {
      key: "",
      image: "",
    },
    navbar: {
      home: "",
      aboutUs: "",
      turnkey: "",
      productRange: "",
      kurversValves: "",
      quality: "",
      careers: "",
      contactUs: "",
    },
  },
  contact: {
    country: [
      {
        key: "",
        heading: "",
        email: "",
        address1: "",
        address2: "",
        phone: "",
        countryIdentifier: "",
        mapElement: "",
      },
    ],
  },
  footer: {
    accreditationLogo: [
      {
        key: "",
        image: "",
      },
    ],
    cmpny: {
      Name: "",
      City: "",
      Description: "",
      Street: "",
      Country: "",
      Tel: "",
      Fax: "",
      Mail: "",
      Linkedin: "",
      Copyright: "",
    },
  },
  quality: {
    mainHeading: "",
    section1: {
      key: "",
      image: "",
      heading: "",
      subHeading: "",
    },
    section2: {
      heading: "",
      subHeading: "",
    },
    section3: {
      heading: "",
      subHeading: "",
    },
  },
};

export function transformObject(data) {
  const result = {};

  // Iterate over all keys in the object
  Object.keys(data).forEach((key) => {
    // Split the key by the underscore (_)
    const [mainKey, subKey] = key.split("_");

    if (subKey) {
      // If the mainKey does not exist in the result object, initialize it
      if (!result[mainKey]) {
        result[mainKey] = {};
      }

      // Add the subKey with its value to the mainKey object
      result[mainKey][subKey] = data[key];
    } else {
      result[mainKey] = data[key];
    }
  });

  return result;
}

export function flattenObject(obj, prefix = "", neglectList) {
  const result = {};

  Object.keys(obj).forEach((key) => {
    if (neglectList?.includes(key)) {
      return; // Skip keys in the neglect list
    }
    const value = obj[key];
    const newKey = prefix ? `${prefix}_${key}` : key; // Add prefix if nested

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      // Recursively flatten nested objects
      Object.assign(result, flattenObject(value, newKey));
    } else {
      result[newKey] = value;
    }
  });

  return result;
}

export const ImageDataModalRequired = {
  image: 1,
  heading: 2,
  description: 3,
  buttonText: 4,
  buttonLink: 5,
};

export const ConfImageUploadService = async (img) => {
  const resp = await PostRequest(
    ApiUrl.confImageUpload,
    { file: img },
    HeaderGroup.multipart
  );
  if (resp?.imageKey) {
    return resp.imageKey;
  } else {
    return null;
  }
};
